import React from 'react';
import EmptyStateImage from 'assets/images/plain-design-emptystate.png';
import { Button } from '@cokitchen/cokitchen-components';

const PlainDesignEmptyState = ({ addPlainDesign }: { addPlainDesign: () => void }) => {
  return (
    <div className='flex justify-center items-center'>
      <div className='space-y-4 flex flex-col items-center '>
        <img src={EmptyStateImage} alt='Empty-state' />
        <p className=' text-sm  font-medium text-[#1A1A1A] mx-auto'>
          You haven’t added any plain designs 😅
        </p>
        <Button
          onClick={addPlainDesign}
          color='primary'
          variant='block'
          className='h-[46px] w-[151px] text-sm'>
          Add one now
        </Button>
      </div>
    </div>
  );
};

export default PlainDesignEmptyState;
